import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetResourcesResponseBody } from '../AppResourcesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseAppResourcesQueryValues = {
  appId: string;
};

export const appResourcesQueryKeyFactory: IQueryKeyFactory<
  IUseAppResourcesQueryValues
> = (values) => values && (['appResources', values.appId] as const);

export const useAppResourcesQuery = (
  values?: IUseAppResourcesQueryValues,
  options?: UseQueryOptions<IApiGetResourcesResponseBody, ApiError>,
): UseQueryResult<IApiGetResourcesResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: appResourcesQueryKeyFactory(values),
    queryFn: values ? () => api.appResources.getAll(values.appId) : undefined,
    ...options,
  });
};
